import { render, staticRenderFns } from "./OrdenTarjetas.vue?vue&type=template&id=1355375d&scoped=true&"
import script from "./OrdenTarjetas.vue?vue&type=script&lang=js&"
export * from "./OrdenTarjetas.vue?vue&type=script&lang=js&"
import style0 from "./OrdenTarjetas.vue?vue&type=style&index=0&id=1355375d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1355375d",
  null
  
)

export default component.exports